<template>
  <div class="error_container">
    <div class="img">
      <img src="@/assets/image/404.png" alt="" />
    </div>
    <span>店铺链接失效或店铺信息异常，请重新访问</span>
  </div>
</template>

<script>

export default {
  name: "error",
  data() {
    return {
    };
  },
  methods: {

  }
};
</script>

<style lang="less">
.error_container {
  background: white;
  display: flex;
  align-items: center;
  height: 100%;
  width: 100%;
  overflow: hidden;
  font-size: 0.26rem;
  color: #888888;
  flex-direction: column;
  justify-content: center;
  .img {
    margin: 0 auto;
    width: 8rem;
    height: 5.6rem;
    display: flex;
    align-items: center;
    img {
      width: 100%;
      height: 100%;
    }
  }
  span {
    margin-top: 0.2rem;
  }
}
</style>
